import { ControllerRenderProps } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { getScreenSize } from "@/sideEffects/api";
import React from "react";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { AppSelect, Option } from "@/components/ui/app-select";

export const ScreenSizeSelectGuid: React.FC<{
  field: ControllerRenderProps<any>;
}> = ({ field }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const { data, isLoading } = useQuery({
    queryFn: () =>
      getScreenSize(
        {
          numberOfObjectsPerPage: 1000,
          pageNumber: 1,
        },
        {
          Firm_Id: String(activeFirm?.firmGuid),
        }
      ),
    queryKey: ["getScreenSize"],
  });

  const options: Option[] = (data?.data?.result || []).map(
    (r) =>
      ({
        value: r.id,
        label: r.name,
      } satisfies Option)
  );

  return (
    <AppSelect
      value={field.value}
      onChange={field.onChange}
      options={options}
      isLoading={isLoading}
      placeholder={t("entities.screenSize")}
      label={t("entities.screenSize")}
    />
  );
};
